function readBlobText(blob) {
  return new Promise(function (resolve) {
    if (!blob || typeof blob.text !== "function") {
      resolve("");
      return;
    }
    blob.text().then(resolve).catch(function () {
      resolve("");
    });
  });
}

export async function formatReportDownloadError(error) {
  const response = error && error.response;
  if (!response) {
    return (error && error.message) || "error desconocido";
  }

  const status = response.status;
  let detail = "";

  if (response.data && typeof response.data.text === "function") {
    const raw = await readBlobText(response.data);
    if (raw) {
      try {
        const parsed = JSON.parse(raw);
        if (parsed && parsed.message) {
          detail = parsed.message;
          if (parsed.template_file) {
            detail += " · Template: " + parsed.template_file;
          }
        } else {
          detail = raw.slice(0, 240);
        }
      } catch (parseErr) {
        detail = raw.slice(0, 240);
      }
    }
  } else if (response.data && response.data.message) {
    detail = response.data.message;
  }

  if (detail) return "HTTP " + status + ": " + detail;
  return "HTTP " + status;
}
